
import request from '@/util/request.js'
import web from '@/util/web.js'
// import axios from '@/util/request.js'
 
export const wapHome = (id) => request({
  url: `http://localhost:8080/wap/home/556124418804690944`,
  method: 'get',
  params: {
    id
  }
})